import {
  Component,
  OnInit,
  ElementRef,
  NgZone,
  HostBinding,
  Input,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import 'fullcalendar';
import { OptionsInput, View, EventObjectInput } from 'fullcalendar';
import * as $ from 'jquery';
import {
  DayClick,
  ViewRender,
  EventRender,
  NguFullCal
} from './ngu-fullcalendar';
import { Subject } from 'rxjs';
import { Moment } from 'moment';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ngu-fullcalendar',
  templateUrl: './ngu-fullcalendar.component.html',
  styleUrls: ['./ngu-fullcalendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class NguFullcalendar implements OnInit, AfterViewInit {
  private _options: OptionsInput;
  private _eventData: any;
  private _calendarId: JQuery<HTMLElement>;
  @Input('options')
  set options(data: OptionsInput) {
    this._options = data;
    this._calendarId && this._setOptions();
  }
  viewRender = new Subject<NguFullCal['ViewRender']>();
  dayClick = new Subject<NguFullCal['DayClick']>();
  eventRender = new Subject<NguFullCal['EventRender']>();
  eventAfterRender = new Subject<NguFullCal['eventAfterRender']>();

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) {}

  ngOnInit() {
    this._calendarId = $(this.el.nativeElement);
  }

  ngAfterViewInit() {
    this._setOptions();
    this._eventData && this._rendererEvents();
  }

  set events(events) {
    this._eventData = events;
    this._calendarId && this._rendererEvents();
  }

  private _setOptions(): void {
    this._options.viewRender = (view, element) => {
      this.viewRender.next([view, element]);
      // console.log('viewRender');
    };
    this._options.dayClick = (date, jsEvent, view) => {
      this.dayClick.next([date, jsEvent, view]);
      // console.log('dayClick');
    };
    this._options.eventRender = (event, element, view) => {
      this.eventRender.next([event, element, view]);
     // console.log(element);
    };
    this._options.eventAfterRender = (event, element, view) => {
      this.eventAfterRender.next([event, element, view]);
      // console.log('eventAfterRender');
    };

    this.fullCalendar(this._options);
    this.cdr.detectChanges();
  }

  fullCalendar(...args: any[]): any {
    if (!args) {
      return;
    }
    switch (args.length) {
      case 0:
        return;
      case 1:
        return this._calendarId.fullCalendar(args[0]);
      case 2:
        return this._calendarId.fullCalendar(args[0], args[1]);
      case 3:
        return this._calendarId.fullCalendar(args[0], args[1], args[2]);
    }
  }

  private _rendererEvents() {
    this.fullCalendar('removeEvents');
    if (this._eventData && this._eventData[0]) {
      this.fullCalendar('renderEvents', this._eventData, true);
      this.fullCalendar('rerenderEvents');
    }
  }

  get getView(): View {
    return this.fullCalendar('getView');
  }
}
